import React from 'react';
import { RouterProvider, createBrowserRouter, Route } from 'react-router-dom';
import { screens } from '../screens';


export enum Routes {
  // Home = '/:id',
  // Home1 = '/',
  // Menu = '/menu',
  Shop = '/:id',
  Shop1 = '/',
  OrderHistory = '/orders',
  PlacedOrders = '/placed-orders',
  OrderDetails = '/order-details',
  ViewOrder = '/view-order/:orderId',
  // Checkout = '/checkout',
  // OrderSuccessful = '/order-successful',
  OrderSuccessful = '/order-successful/:orderId'

}

const stack = createBrowserRouter([
  // {
  //   path: Routes.Home,
  //   element: <screens.Home />,
  // },
  // {
  //   path: Routes.Home1,
  //   element: <screens.Home />,
  // },
  // {
  //   path: Routes.Menu,
  //   element: <screens.Menu />,
  // },
  {
    path: Routes.Shop,
    element: <screens.Shop />,
  },
  {
    path: Routes.Shop1,
    element: <screens.Shop />,
  },
  {
    path: Routes.OrderHistory,
    element: <screens.OrderHistory />,

  },
  // {
  //   path: Routes.PlacedOrders,
  //   element: <screens.PlacedOrders />
  // },
  {
    path: Routes.OrderDetails,
    element: <screens.OrderDetails />
  },
  {
    path: Routes.ViewOrder,
    element: <screens.ViewOrder />
  },
  // {
  //   path: Routes.OrderDetails + ':orderId',
  //   element: <screens.OrderDetails />
  // },
  // {
  //   path: Routes.Checkout,
  //   element: <screens.Checkout />,
  // },
  {
    path: Routes.OrderSuccessful,
    element: <screens.OrderSuccessful />,
  },


]);

export const StackNavigator: React.FC = () => {
  return <RouterProvider router={stack} />;
};
